<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="1200px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Edit Purchase Fixed Asset information') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap justify-end>
            <v-flex shrink>
              <v-chip v-if="fileSelected" :selected="fileSelected" @input="removeFile()" close dark color="primary">
                <v-avatar>
                  <v-icon>insert_drive_file</v-icon>
                </v-avatar>
                <a
                  v-if="updateForm.attachment !== null"
                  :href="`${baseUrls.images}/${updateForm.attachment}`"
                  target="_blank"
                  style="color: white; text-decoration: none"
                >
                  {{ $t('Click to View Attachment') }}
                </a>
                <span v-else>{{ fileName | truncate }}</span>
              </v-chip>
              <v-btn :disabled="fileSelected" @click="chooseFile" color="primary" class="white--text">
                <v-icon left dark>attach_file</v-icon>
                {{ $t('Attach file') }}
              </v-btn>
              <input
                type="file"
                name="file"
                ref="fileInput"
                style="visibility:hidden; width:0; position:absolute; top:-9999px"
                @input="onSelectFile"
              />
            </v-flex>
          </v-layout>

          <v-layout row wrap justify-content-end>
            <v-flex xs3 class="pa-2">
              <v-text-field
                v-model="updateForm.supplier_invoice_number"
                :label="`${$t('Supplier Invoice Number')} *`"
                name="Supplier Invoice Number"
                hide-details
                box
                background-color="white"
                :error="errors.has('Supplier Invoice Number')"
                v-validate="'required'"
              />
            </v-flex>
            <v-flex pa-2>
              <v-autocomplete
                v-model="updateForm.vender_id_fk"
                :label="`${$t('Supplier')} *`"
                hide-details
                :items="vendersList"
                box
                data-vv-name="Supplier"
                background-color="white"
                :error="errors.has('Supplier')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex shrink pt-2 v-if="hasPermissions(['vender_store'])">
              <v-tooltip top>
                <v-btn label @click="$emit('add-supplier')" slot="activator" icon fab small color="green">
                  <v-icon color="white" size="25">add</v-icon>
                </v-btn>
                <span>{{ $t('Add new supplier') }}</span>
              </v-tooltip>
            </v-flex>

            <v-flex xs3 pa-2>
              <v-menu v-model="billDateMenu" full-width max-width="290" :close-on-content-click="false">
                <v-text-field
                  slot="activator"
                  :value="updateForm.bill_date"
                  :label="`${$t('Bill Date')} *`"
                  prepend-inner-icon="event"
                  box
                  readonly
                  hide-details
                  name="bill_date"
                  background-color="white"
                  autocomplete="off"
                  :error="errors.has('bill_date')"
                  v-validate="'required|date_format:yyyy-MM-dd'"
                />
                <v-date-picker @change="billDateMenu = false" v-model="updateForm.bill_date" />
              </v-menu>
            </v-flex>

            <!--            <v-flex xs2 pa-2>-->
            <!--              <v-autocomplete-->
            <!--                v-model="updateForm.cash_or_opening_balance"-->
            <!--                :label="`${$t('Payment Type')} *`"-->
            <!--                hide-details-->
            <!--                :items="paymentTypes"-->
            <!--                box-->
            <!--                readonly-->
            <!--                name="cash_or_opening_balance"-->
            <!--                background-color="white"-->
            <!--                :error="errors.has('cash_or_opening_balance')"-->
            <!--                v-validate="'required'"-->
            <!--              />-->
            <!--            </v-flex>-->

            <v-flex xs12 style="margin-top: 20px">
              <v-layout row wrap class="form-table-header">
                <v-flex xs1 class="pa-2 form-table-content">#</v-flex>
                <v-flex xs2 class="pa-2 form-table-content">{{ $t('Product') }}</v-flex>

                <v-flex
                  xs1
                  v-if="hasPermissions(['fixed_assets_store'])"
                  style="padding-top: 3px"
                  class="form-table-content"
                >
                  <v-tooltip top>
                    <v-btn label @click="$emit('add-fixed-asset')" slot="activator" icon small color="green">
                      <v-icon color="white">add</v-icon>
                    </v-btn>
                    <span>{{ $t('Add new product') }}</span>
                  </v-tooltip>
                </v-flex>

                <v-flex xs1 class="pa-2 form-table-content">{{ $t('Lifespan') }}</v-flex>
                <v-flex xs2 class="pa-2 form-table-content">{{ `${$t('Salvage Price')}` }}</v-flex>
                <v-flex xs1 class="pa-2 form-table-content">{{ $t('Quantity') }}</v-flex>
                <v-flex xs1 class="pa-2 form-table-content">{{ `${$t('Price')}` }}</v-flex>
                <v-flex xs2 class="pa-2 form-table-content">{{ `${$t('Total')} (${systemCurrency})` }}</v-flex>
                <v-flex xs1 style="padding-top: 3px" class="form-table-content">
                  <v-tooltip top>
                    <v-btn label @click="addRow()" small slot="activator" icon color="green">
                      <v-icon color="white">add</v-icon>
                    </v-btn>
                    <span>{{ $t('Add new row') }}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>

              <template v-if="rowNumbers > 0">
                <v-layout row wrap v-for="(row, index) in rowNumbers" :key="index">
                  <v-flex xs1 class="pa-1" style="text-align: center; margin-top: 20px; font-size: 16px">{{
                    index + 1
                  }}</v-flex>
                  <v-flex xs3 class="pa-1">
                    <v-autocomplete
                      v-model="updateForm.product_id_fk[index]"
                      :label="`${$t('Product')} *`"
                      :items="assetsList"
                      hide-details
                      box
                      :data-vv-name="'Product' + (index + 1)"
                      background-color="white"
                      :error="errors.has('Product' + (index + 1))"
                      v-validate="'required'"
                    />
                  </v-flex>
                  <v-flex xs1 class="pa-1">
                    <v-text-field
                      v-model.number="updateForm.lifespan[index]"
                      :label="`${$t('Lifespan')} *`"
                      hide-details
                      box
                      :data-vv-name="'Lifespan' + (index + 1)"
                      background-color="white"
                      :error="errors.has('Lifespan' + (index + 1))"
                      v-validate="'required|decimal:3|min_value:0|max_value:99'"
                    />
                  </v-flex>
                  <v-flex xs2 class="pa-1">
                    <v-text-field
                      v-model.number="updateForm.salvage_price[index]"
                      :label="`${$t('Salvage Price')} *`"
                      hide-details
                      box
                      :data-vv-name="'Salvage Price' + (index + 1)"
                      background-color="white"
                      :error="errors.has('Salvage Price' + (index + 1))"
                      v-validate="'required|decimal:3|min_value:0'"
                    />
                  </v-flex>
                  <v-flex xs1 class="pa-1">
                    <v-text-field
                      v-model.number="updateForm.purchase_quantity[index]"
                      :label="`${$t('Quantity')} *`"
                      hide-details
                      box
                      :data-vv-name="'Quantity' + (index + 1)"
                      background-color="white"
                      :error="errors.has('Quantity' + (index + 1))"
                      v-validate="'required|decimal:3|min_value:0'"
                      @input="calculateTotal(index)"
                    />
                  </v-flex>
                  <v-flex xs1 class="pa-1">
                    <v-text-field
                      v-model.number="updateForm.purchase_price[index]"
                      :label="`${$t('Price')} *`"
                      hide-details
                      box
                      :data-vv-name="'Price' + (index + 1)"
                      background-color="white"
                      :error="errors.has('Price' + (index + 1))"
                      v-validate="'required|decimal:3|min_value:0'"
                      @input="calculateTotal(index)"
                    />
                  </v-flex>
                  <v-flex xs2 class="pa-1">
                    <v-text-field
                      v-model="updateForm.total[index]"
                      :label="`${$t('Total')} *`"
                      hide-details
                      box
                      readonly
                      :data-vv-name="'Total' + (index + 1)"
                      background-color="white"
                      :error="errors.has('Total' + (index + 1))"
                      v-validate="'required|decimal:3'"
                    />
                  </v-flex>
                  <v-flex
                    xs1
                    :class="index + 1 === rowNumbers && index + 1 > 1 ? 'pt-3' : 'pa-3'"
                    style="text-align: center"
                  >
                    <v-tooltip top>
                      <v-btn label flat @click="removeRow(index)" small slot="activator" icon color="error">
                        <v-icon>delete</v-icon>
                      </v-btn>
                      <span>{{ $t('Remove this row') }}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="index + 1 === rowNumbers && index + 1 > 1">
                      <v-btn label @click="addRow()" small flat slot="activator" icon>
                        <v-icon size="28" color="green">add_circle</v-icon>
                      </v-btn>
                      <span>{{ $t('Add new row') }}</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </template>
            </v-flex>

            <v-flex pa-2>
              <v-text-field
                v-model="updateForm.total_amount"
                :label="`${$t('Total Amount')} (${systemCurrency}) *`"
                hide-details
                box
                readonly
                name="Total Amount"
                background-color="white"
                :error="errors.has('Total Amount')"
                v-validate="'required|decimal:3'"
              />
            </v-flex>

            <v-flex pa-2>
              <v-text-field
                v-model="updateForm.transport_cost"
                :label="`${$t('Transport Cost')} (${systemCurrency})`"
                hide-details
                box
                name="transfer_cost"
                background-color="white"
                :error="errors.has('transfer_cost')"
                v-validate="'decimal:3'"
                @input="calculateGrandTotalAmount()"
              />
            </v-flex>

            <v-flex pa-2>
              <v-text-field
                v-model="updateForm.other_cost"
                :label="`${$t('Other Cost')} (${systemCurrency})`"
                hide-details
                box
                name="other_cost"
                background-color="white"
                :error="errors.has('other_cost')"
                v-validate="'decimal:3'"
                @input="calculateGrandTotalAmount()"
              />
            </v-flex>

            <v-flex pa-2>
              <v-text-field
                v-model="updateForm.grand_total_amount"
                :label="`${$t('Grand Total Amount')} (${systemCurrency}) *`"
                hide-details
                box
                readonly
                name="grand_total_amount"
                background-color="white"
                :error="errors.has('grand_total_amount')"
                v-validate="'required|decimal:3'"
              />
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :disabled="rowNumbers < 1" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnUpdateLoading: false,
      billDateMenu: false,
      rowNumbers: 0,
      updateForm: {
        purchase_id: 0,
        supplier_invoice_number: '',
        attachment: '',
        vender_id_fk: '',
        bill_date: '',
        cash_or_opening_balance: '',
        total_amount: '',
        transport_cost: 0,
        other_cost: 0,
        grand_total_amount: 0,
        product_id_fk: [],
        lifespan: [],
        salvage_price: [],
        purchase_quantity: [],
        purchase_price: [],
        total: []
      },
      fileSelected: false,
      fileName: '',
      fileData: null,
      fileInput: null,
      theFile: null
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      purchaseInfo: 'purchasesFixedAssets/getPurchaseInfo',
      assetsList: 'fixedAssets/getFullFixedAssetsList',
      vendersList: 'suppliers/getFullVendersList',
      paymentTypes: 'purchases/getPaymentTypes',
      settings: 'configurations/getSystemSettings'
    }),
    hasOpeningBalance() {
      return this.settings.opening_balance_status === 'Active'
    }
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          if (this.hasOpeningBalance) {
            this.paymentTypes.push({ value: 'Opening Balance', text: this.$t('Opening Balance') })
          }
          this.removeFile()
          this.rowNumbers = this.purchaseInfo.data_detail.length
          this.updateForm.supplier_invoice_number = this.purchaseInfo.data.supplier_invoice_number
          this.updateForm.vender_id_fk = this.purchaseInfo.data.vender_id_fk
          this.updateForm.bill_date = this.purchaseInfo.data.bill_date
          this.updateForm.cash_or_opening_balance = this.purchaseInfo.data.cash_or_opening_balance
          this.updateForm.total_amount = this.purchaseInfo.data.total_amount
          this.updateForm.transport_cost = this.purchaseInfo.data.transfer_cost
          this.updateForm.other_cost = this.purchaseInfo.data.other_cost
          this.updateForm.grand_total_amount = this.purchaseInfo.data.grand_total_amount
          this.updateForm.attachment = this.purchaseInfo.data.attachment
          this.updateForm.purchase_id = Number(this.purchaseInfo.data.purchase_id)

          this.updateForm.product_id_fk = []
          this.updateForm.lifespan = []
          this.updateForm.salvage_price = []
          this.updateForm.purchase_quantity = []
          this.updateForm.purchase_price = []
          this.updateForm.total = []

          this.purchaseInfo.data_detail.forEach(c => {
            this.updateForm.product_id_fk.push(Number(c.product_id_fk))
            this.updateForm.lifespan.push(Number(c.lifespan))
            this.updateForm.salvage_price.push(Number(c.salvage_price))
            this.updateForm.purchase_quantity.push(Number(c.purchase_quantity))
            this.updateForm.purchase_price.push(Number(c.purchase_price))
            this.updateForm.total.push(Number(c.total).toFixed(2))
          })

          if (this.updateForm.attachment) {
            this.fileSelected = true
          }

          this.addEscKeyListener()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updatePurchaseInfo: 'purchasesFixedAssets/updatePurchaseInfo'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    chooseFile() {
      this.$refs.fileInput.click()
    },

    onSelectFile() {
      this.fileInput = this.$refs.fileInput
      this.theFile = this.fileInput.files

      if (this.theFile && this.theFile[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.fileData = e.target.result
        }
        reader.readAsDataURL(this.theFile[0])
        this.$emit('input', this.theFile[0])
        this.fileName = this.theFile[0].name
        this.fileSelected = true
      }
    },

    removeFile() {
      this.fileData = null
      this.fileInput = null
      this.theFile = null
      this.$refs.fileInput.value = null
      this.updateForm.attachment = null
      this.fileName = ''
      this.fileSelected = false
    },

    addRow() {
      this.updateForm.total[this.rowNumbers] = 0
      this.rowNumbers = this.rowNumbers + 1
    },

    removeRow(index) {
      this.rowNumbers = this.rowNumbers - 1
      this.updateForm.product_id_fk.splice(index, 1)
      this.updateForm.purchase_quantity.splice(index, 1)
      this.updateForm.lifespan.splice(index, 1)
      this.updateForm.salvage_price.splice(index, 1)
      this.updateForm.purchase_price.splice(index, 1)
      this.updateForm.total_amount -= this.updateForm.total[index]
      this.updateForm.total.splice(index, 1)
    },

    calculateTotal(index) {
      const quantity = this.updateForm.purchase_quantity[index] || 0
      const price = this.updateForm.purchase_price[index] || 0
      this.updateForm.total[index] = Number((quantity * price).toFixed(2))
      this.calculateTotalAmount()
    },

    calculateTotalAmount() {
      this.updateForm.total_amount = this.updateForm.total.reduce((a, b) => a + b, 0)
      this.calculateGrandTotalAmount()
    },

    calculateGrandTotalAmount() {
      this.updateForm.grand_total_amount = (
        Number(this.updateForm.total_amount) +
        Number(this.updateForm.transport_cost) +
        Number(this.updateForm.other_cost)
      ).toFixed(2)
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnUpdateLoading = true
          let formData = new FormData(event.target)
          formData.append('supplier_invoice_number', this.updateForm.supplier_invoice_number)
          formData.append('cash_or_opening_balance', this.updateForm.cash_or_opening_balance)
          formData.append('vender_id_fk', this.updateForm.vender_id_fk)
          formData.append('total_amount', this.updateForm.total_amount)
          if (this.theFile === null && this.updateForm.attachment === null) {
            formData.append('attachment', '')
          } else if (this.theFile !== null) {
            formData.append('attachment', this.theFile[0])
          }

          this.updateForm.product_id_fk.forEach((p, index) => {
            formData.append('product_id_fk[' + [index] + ']', p)
          })

          this.updateForm.lifespan.forEach((p, index) => {
            formData.append('lifespan[' + [index] + ']', p)
          })

          this.updateForm.salvage_price.forEach((p, index) => {
            formData.append('salvage_price[' + [index] + ']', p)
          })

          this.updateForm.purchase_quantity.forEach((q, index) => {
            formData.append('purchase_quantity[' + [index] + ']', q)
          })

          this.updateForm.purchase_price.forEach((p, index) => {
            formData.append('purchase_price[' + [index] + ']', p)
          })

          this.updateForm.total.forEach((t, index) => {
            formData.append('total[' + [index] + ']', t)
          })

          let payload = { id: this.updateForm.purchase_id, formData }
          this.updatePurchaseInfo(payload)
            .then(() => {
              this.updateForm.product_id_fk = []
              this.updateForm.lifespan = []
              this.updateForm.salvage_price = []
              this.updateForm.purchase_quantity = []
              this.updateForm.purchase_price = []
              this.updateForm.expire_date = []
              this.updateForm.total = []
              this.btnUpdateLoading = false
              this.$emit('updated')
            })
            .catch(() => {
              this.btnUpdateLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped />
